<div class="register-page">
  @if (!showSuccessScreen) {
  <div>
    <div class="bg-light min-vh-100 d-flex flex-row align-items-center">
      <c-container>
        <c-row class="justify-content-center">
          <c-col lg="10" xl="8">
            <c-card class="p-0 overflow-hidden shadow-sm">
              <!-- Wizard header -->
              <div class="p-4 border-bottom bg-white">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex gap-2 align-items-center">
                    <span
                      class="badge rounded-pill"
                      [class.bg-primary]="step === 1"
                      [class.bg-secondary]="step !== 1"
                      >1</span
                    >
                    <strong>Account</strong>
                  </div>
                  <div class="flex-grow-1 px-3">
                    <c-progress thin>
                      <c-progress-bar
                        [value]="step === 1 ? 50 : 100"
                      ></c-progress-bar>
                    </c-progress>
                  </div>
                  <div class="d-flex gap-2 align-items-center">
                    <span
                      class="badge rounded-pill"
                      [class.bg-primary]="step === 2"
                      [class.bg-secondary]="step !== 2"
                      >2</span
                    >
                    <strong>Company</strong>
                  </div>
                </div>
              </div>
              <c-card-body class="p-4">
                <form (ngSubmit)="onSubmit()" #registerForm="ngForm" novalidate>
                  @if (serverError) {
                  <div class="alert alert-danger">
                    {{ serverError }}
                  </div>
                  }
                  <!-- STEP 1: Account -->
                  <div
                    [hidden]="step !== 1"
                    class="animate__animated animate__fadeIn"
                  >
                    <!-- Access Code -->
                    <c-input-group class="mb-3">
                      <span cInputGroupText
                        ><svg [cIcon]="icons.cilFingerprint"></svg
                      ></span>
                      <input
                        name="adminAccessKey"
                        cFormControl
                        placeholder="Access Code"
                        [(ngModel)]="formData.adminAccessKey"
                        (ngModelChange)="update('adminAccessKey', $event)"
                        #keyRef="ngModel"
                        required
                        autocomplete="one-time-code"
                        class="form-control-lg"
                      />
                    </c-input-group>
                    @if (keyRef.invalid && (keyRef.dirty || keyRef.touched)) {
                    <div class="text-danger mb-2">Access code is required.</div>
                    }
                    <!-- Email -->
                    <c-input-group class="mb-3">
                      <span cInputGroupText
                        ><svg [cIcon]="icons.cilEnvelopeClosed"></svg
                      ></span>
                      <input
                        name="email"
                        cFormControl
                        type="email"
                        placeholder="Email"
                        [(ngModel)]="formData.email"
                        (ngModelChange)="update('email', $event)"
                        #emailRef="ngModel"
                        required
                        email
                        autocomplete="email"
                        class="form-control-lg"
                      />
                    </c-input-group>
                    @if ( emailRef.invalid && (emailRef.dirty ||
                    emailRef.touched) ) {
                    <div class="text-danger mb-2">
                      @if (emailRef.errors?.['required']) {
                      <span>Email is required.</span>
                      } @if (emailRef.errors?.['email']) {
                      <span>Enter a valid email.</span>
                      }
                    </div>
                    }
                    <!-- Password -->
                    <c-input-group class="mb-3">
                      <span cInputGroupText
                        ><svg [cIcon]="icons.cilLockLocked"></svg
                      ></span>
                      <input
                        name="password"
                        [type]="showPassword ? 'text' : 'password'"
                        cFormControl
                        placeholder="Password (min 10 chars)"
                        [(ngModel)]="formData.password"
                        (ngModelChange)="update('password', $event)"
                        #passwordRef="ngModel"
                        required
                        minlength="10"
                        autocomplete="new-password"
                        class="form-control-lg"
                      />
                      <button
                        type="button"
                        cButton
                        color="secondary"
                        (click)="togglePasswordVisibility()"
                      >
                        {{ showPassword ? "Hide" : "Show" }}
                      </button>
                    </c-input-group>
                    <!-- Strength meter -->
                    <div class="mb-2">
                      <c-progress thin>
                        <c-progress-bar
                          [value]="passwordStrengthValue"
                        ></c-progress-bar>
                      </c-progress>
                      <small>
                        Password strength:
                        <strong
                          [ngClass]="{
                            'text-danger': passwordStrengthLevel === 'weak',
                            'text-warning': passwordStrengthLevel === 'medium',
                            'text-success': passwordStrengthLevel === 'strong'
                          }"
                        >
                          {{ passwordStrengthLevel }}
                        </strong>
                      </small>
                    </div>
                    <!-- Inline validation -->
                    @if (passwordRef.invalid && (passwordRef.dirty ||
                    passwordRef.touched)) {
                    <div class="text-danger mb-2">
                      @if (passwordRef.errors?.['required']) {
                      <span>Password is required.</span>
                      } @if (passwordRef.errors?.['minlength']) {
                      <span>At least 10 characters.</span>
                      }
                    </div>
                    }
                    <!-- Repeat Password -->
                    <c-input-group class="mb-3">
                      <span cInputGroupText
                        ><svg [cIcon]="icons.cilLockLocked"></svg
                      ></span>
                      <input
                        name="repeatPassword"
                        type="password"
                        cFormControl
                        placeholder="Repeat Password"
                        [(ngModel)]="formData.repeatPassword"
                        (ngModelChange)="update('repeatPassword', $event)"
                        #repeatRef="ngModel"
                        required
                        autocomplete="new-password"
                        class="form-control-lg"
                      />
                    </c-input-group>
                    @if ( formData.password && formData.repeatPassword &&
                    formData.password !== formData.repeatPassword ) {
                    <div class="text-danger mb-2">Passwords do not match.</div>
                    }
                    <!-- Language -->
                    <div class="mb-3">
                      <select
                        name="language"
                        cFormControl
                        class="form-control-lg form-select"
                        [(ngModel)]="formData.language"
                        (ngModelChange)="update('language', $event)"
                      >
                        <option value="en">🇺🇸 English</option>
                        <option value="tr">🇹🇷 Turkish</option>
                        <option value="es">🇪🇸 Spanish</option>
                        <option value="el">🇬🇷 Greek</option>
                        <option value="de">🇩🇪 German</option>
                      </select>
                    </div>
                    <div class="d-flex justify-content-end">
                      <button
                        type="button"
                        cButton
                        class="btn--primary-gradient"
                        class="btn btn--primary-gradient"
                        [disabled]="!step1Valid || loading"
                        (click)="next()"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                  <!-- STEP 2: Company -->
                  <div
                    [hidden]="step !== 2"
                    class="animate__animated animate__fadeIn"
                  >
                    <div class="row g-4">
                      <div class="col-md-6">
                        <c-input-group class="mb-3">
                          <span cInputGroupText
                            ><svg [cIcon]="icons.cilBuilding"></svg
                          ></span>
                          <input
                            name="companyName"
                            cFormControl
                            placeholder="Company Name"
                            [(ngModel)]="formData.companyName"
                            (ngModelChange)="update('companyName', $event)"
                            #companyNameRef="ngModel"
                            required
                            class="form-control-lg"
                          />
                        </c-input-group>
                        @if ( companyNameRef.invalid && (companyNameRef.dirty ||
                        companyNameRef.touched) ) {
                        <div class="text-danger mb-2">
                          Company name is required.
                        </div>
                        }
                        <c-input-group class="mb-3">
                          <span cInputGroupText
                            ><svg [cIcon]="icons.cilLayers"></svg
                          ></span>
                          <select
                            name="companyType"
                            cFormControl
                            [(ngModel)]="formData.companyType"
                            (ngModelChange)="update('companyType', $event)"
                            #companyTypeRef="ngModel"
                            required
                            class="form-control-lg form-select"
                          >
                            <option value="" disabled>
                              Select Business Type
                            </option>
                            <option value="Restaurant">Restaurant</option>
                            <option value="Hotel">Hotel</option>
                            <option value="Vineyard">Vineyard</option>
                            <option value="cafe">Café</option>
                            <option value="Transfer">Transfer</option>
                            <option value="default">Default</option>
                            <option value="defaultplus">Default Plus</option>
                          </select>
                        </c-input-group>
                        @if ( companyTypeRef.invalid && (companyTypeRef.dirty ||
                        companyTypeRef.touched) ) {
                        <div class="text-danger mb-2">
                          Company type is required.
                        </div>
                        }
                        <c-input-group class="mb-3">
                          <span cInputGroupText
                            ><svg [cIcon]="icons.cilHome"></svg
                          ></span>
                          <input
                            name="branchOffice"
                            cFormControl
                            placeholder="Branch Office"
                            [(ngModel)]="formData.branchOffice"
                            (ngModelChange)="update('branchOffice', $event)"
                            #branchRef="ngModel"
                            required
                            class="form-control-lg"
                          />
                        </c-input-group>
                        @if ( branchRef.invalid && (branchRef.dirty ||
                        branchRef.touched) ) {
                        <div class="text-danger mb-2">
                          Branch office is required.
                        </div>
                        }
                      </div>
                      <div class="col-md-6">
                        <c-input-group class="mb-3">
                          <span cInputGroupText
                            ><svg [cIcon]="icons.cilPhone"></svg
                          ></span>
                          <input
                            name="phoneNumber"
                            type="tel"
                            cFormControl
                            placeholder="Phone Number"
                            [(ngModel)]="formData.phoneNumber"
                            (ngModelChange)="update('phoneNumber', $event)"
                            #phoneRef="ngModel"
                            required
                            class="form-control-lg"
                          />
                        </c-input-group>
                        @if ( phoneRef.invalid && (phoneRef.dirty ||
                        phoneRef.touched) ) {
                        <div class="text-danger mb-2">
                          Phone number is required.
                        </div>
                        }
                        <div class="form-check mb-3">
                          <input
                            id="admin"
                            type="checkbox"
                            class="form-check-input"
                            name="admin"
                            [(ngModel)]="formData.admin"
                            (ngModelChange)="update('admin', $event)"
                          />
                          <label for="admin" class="form-check-label"
                            >Admin</label
                          >
                        </div>
                      </div>
                    </div>
                    <c-input-group class="mb-4">
                      <span cInputGroupText
                        ><svg [cIcon]="icons.cilLocationPin"></svg
                      ></span>
                      <input
                        name="address"
                        cFormControl
                        placeholder="Address"
                        [(ngModel)]="formData.address"
                        (ngModelChange)="update('address', $event)"
                        #addressRef="ngModel"
                        required
                        class="form-control-lg"
                      />
                    </c-input-group>
                    @if ( addressRef.invalid && (addressRef.dirty ||
                    addressRef.touched) ) {
                    <div class="text-danger mb-2">Address is required.</div>
                    }
                    <div class="d-flex justify-content-between">
                      <button
                        type="button"
                        cButton
                        class="btn btn-outline-secondary"
                        (click)="back()"
                        [disabled]="loading"
                      >
                        Back
                      </button>
                      <button
                        type="submit"
                        cButton
                        class="btn btn--primary-gradient"
                        [disabled]="!step2Valid || loading"
                      >
                        @if (!loading) {
                        <span>Create Account</span>
                        } @if (loading) {
                        <span
                          class="d-flex align-items-center justify-content-center gap-2"
                        >
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Creating…
                        </span>
                        }
                      </button>
                    </div>
                  </div>
                </form>
              </c-card-body>
            </c-card>
          </c-col>
        </c-row>
      </c-container>
    </div>
  </div>
  }

  <!-- Success screen -->
  @if (showSuccessScreen) {
  <div class="success-wrap">
    <div class="success-card">
      <!-- Animated checkmark -->
      <svg class="checkmark" viewBox="0 0 52 52" aria-hidden="true">
        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
        <path class="checkmark__check" fill="none" d="M14 27l7 7 17-17" />
      </svg>
      <h2 class="title">Account created</h2>
      <p class="subtitle">
        We sent you a verification email. Please confirm to continue.
      </p>
      <div class="actions">
        <button
          cButton
          class="btn--primary-gradient"
          size="lg"
          class="px-4"
          (click)="redirectToMain()"
        >
          OK
        </button>
      </div>
    </div>
  </div>
  }
</div>
